import * as keyapis_exchange_v1_events_pb from "./v1/keyapis_exchange_events_v1.pb";
import * as keyapis_exchange_v1_message_pb from "./v1/keyapis_exchange_message_v1.pb";
import * as keyapis_exchange_v1_system_pb from "./v1/keyapis_exchange_system_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_exchange_v1_events_pb,
      message: keyapis_exchange_v1_message_pb,
      system: keyapis_exchange_v1_system_pb,
    },
  },
};
